import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifiBadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_bad"}/>
}
